document.addEventListener('DOMContentLoaded', function() {
  const closeButtons = document.querySelectorAll('.announcement-close');
  const announcementBar = document.getElementById('announcement-bar');
  
  announcementBar.classList.remove('hidden');
  
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
    
      announcementBar.classList.add('hidden');
      

      sessionStorage.setItem('announcementClosed', 'true');
    });
  });
  

  if (sessionStorage.getItem('announcementClosed') === 'true') {
    announcementBar.classList.add('hidden');
  }

  window.addEventListener('beforeunload', function() {
    sessionStorage.removeItem('announcementClosed');
  });
});